import {MutableRefObject, useEffect} from 'react';

export function useClickOutside(
    ref: MutableRefObject<HTMLElement | null>,
    action: (e: MouseEvent) => void,
    ignoreRef?: MutableRefObject<HTMLElement | null>,
) {
    useEffect(() => {
        const handleClick = (e: MouseEvent) => {
            if (
                ignoreRef !== undefined &&
                e.target !== null &&
                ignoreRef.current !== null &&
                e.target instanceof Node &&
                ignoreRef.current.contains(e.target)
            ) {
                return;
            }

            if (
                e.target !== null &&
                ref.current !== null &&
                e.target instanceof Node &&
                !ref.current.contains(e.target)
            ) {
                action(e);
            }
        };
        document.addEventListener('mousedown', handleClick);
        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
    }, [ref, action, ignoreRef]);
}
